import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DataContainer from 'Components/UI/DataContainer';

import { useSurveyStepContext } from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepContext';
import SurveyStepContent from './SurveyStepContent';

const styles = () => ({
  root: {},
});

const SurveyStepContainer = ({
  className,
  classes,
}) => {
  const {
    isInitializing,
    initializingError,
  } = useSurveyStepContext();

  return (
    <DataContainer
      className={classes.container}
      component={SurveyStepContent}
      componentProps={{
        className: classNames(classes.root, className),
      }}
      loading={isInitializing}
      loadingError={initializingError}
      ErrorListProps={{
        title: 'An error occurred while initializing the survey.',
      }}
    />
  );
};

SurveyStepContainer.defaultProps = {
  className: '',
};

SurveyStepContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SurveyStepContainer);
